import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import { ICONS } from '../../../icons';
import Icon from '../../../icons/Icon';

import scss from './MessageCard.module.scss';

function BackupActions({ onRestore, id, isDisabled }) {
  const { t } = useTranslation('id8');

  const handleRestoreMessage = () => {
    onRestore(id);
  };

  return (
    <CommonButton
      styleColor={BUTTON_STYLES.SECONDARY}
      maxWidth={150}
      onClick={handleRestoreMessage}
      disabled={isDisabled}>
      {t('restoreMessage')}
      <Icon icon={ICONS.RoundArrow} disableCommonColors className={scss.reclaimIcon} />
    </CommonButton>
  );
}

export default memo(BackupActions);
